import { makeStyles } from '@material-ui/core/styles';
import { FONT_WEIGHT_BOLD } from '../components/utilities/Material';
import { getStyle, mergeStyles } from './stylesSelector';
import { cloneDeep } from 'lodash';
import { styleBreakMobile } from '../components/utilities/layouts/Globals';

export const TaskHomeBetweenStyles = makeStyles(theme => {
    /* Default styles */
    const styles = {
        root: {
            padding: '0px',
            marginTop: theme.spacing(15),
            marginBottom: theme.spacing(3),
            [styleBreakMobile(theme)]: {
                marginTop: theme.spacing(10),
            },
            boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.25)',
            borderRadius: '5px',
        },
        bigMobileScreen: {
            marginTop: theme.spacing(8),
        },
        h2Text: {
            fontWeight: FONT_WEIGHT_BOLD,
        },
        dateText: {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(3),
            textAlign: 'center',
            fontWeight: FONT_WEIGHT_BOLD,
            color: theme.palette.info.contrastText,
        },
        taskBoard: {
            paddingTop: theme.spacing(3),
            paddingRight: theme.spacing(3),
            paddingLeft: theme.spacing(3),
            paddingBottom: theme.spacing(3),
            boxShadow: '0px 2px 4px rgba(179, 179, 179, 0.5)',
            borderRadius: '4px',
        },
        datePaper: {
            padding: theme.spacing(1),
            marginTop: theme.spacing(2),
            background: theme.palette.info.main,
            borderRadius: '4px',
        },
    };

    /* Add watchman specific styles */
    let watchmanStyles = {
        dateText: {
            color: theme.palette.primary.dark,
        },
        datePaper: {
            background: theme.palette.primary.light,
        },
    };
    // merge
    watchmanStyles = mergeStyles(cloneDeep(styles), watchmanStyles);

    const stylesMap = {
        ned: styles,
        watchman: watchmanStyles,
    };

    return getStyle(stylesMap);
});
